// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__J_ciE","label":"Category_label__OVUsF","content":"Category_content__3LQq-","header":"Category_header__23I-0","location":"Category_location__uNjrU"};